<template>
  <div class="Penggunasistem">
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.message }}
    </v-snackbar>

    <v-card style="margin-top: 250px">
    <v-breadcrumbs :items="item">
      <v-breadcrumbs-item
        slot="items"
        slot-scope="{ items }"
        exact
        :to="items.to"
        :disabled="items.disabled"
      >
        {{ items.text }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t("senaraipengguna") }}
      </v-card-title>
      <v-form ref="formtapisanpengguna">
        <v-container>
          <v-row>
          </v-row>
        </v-container>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="search"
              outlined
              dense
              v-bind:label="$t('cari')"
              class="mx-4"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-col class="text-right">
              <v-btn color="light-blue white--text" @click="modaltambahpengguna"
                ><span class="material-icons">add</span
                >{{ $t("tambah") }}</v-btn
              >
              &nbsp;
              <v-btn color="green white--text" @click="caridatapengguna"
                ><span class="material-icons">search</span
                >{{ $t("cari") }}</v-btn
              ></v-col
            >
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
        :headers="headers"
        :items="datapengguna"
        :search="search"
        :items-per-page="20"
        class="elevation-1"
        @click:row="modalkemaskinidatapengguna"
      >
        <template v-slot:[`item.statuslogmasuk`]="{ item }">
          <span v-bind:class="warnastatuslogmasuk(item.statuslogmasuk)">{{
            item.statuslogmasuk
          }}</span>
        </template>
        <template v-slot:[`item.statusakaun`]="{ item }">
          <span v-bind:class="statusakaun(item.statusakaun)">{{
            item.statusakaun
          }}</span>
        </template>
        <template v-slot:top>
          <v-dialog v-model="dialogtambahpengguna" persistent max-width="500px">
            <v-card>
              <v-form ref="formtambahpengguna">
                <v-card-title class="text-h5 grey lighten-2">
                  <span class="text-h5">{{ $t("tambahpengguna") }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          v-model="daftarnama"
                          :rules="[required('nama'), namamin6]"
                          :error-messages="msgnamamin6"
                          v-bind:label="$t('nama')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          v-model="daftaremel"
                          :rules="[
                            required('emel'),
                            emelsudahwujud,
                            rules.email,
                          ]"
                          :error-messages="msgkemaskiniemelsudahwujud"
                          v-bind:label="$t('emel')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          :items="lookupnegeri"
                          v-model="daftarnegeri"
                          :rules="[required('negeri')]"
                          outlined
                          dense
                          item-text="negeri"
                          item-value="id"
                          v-bind:label="$t('negeri')"
                          item-disabled="disable"
                          :disabled="disablenegeri"
                          required
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          :items="daftarlookupperanan"
                          v-model="daftaperanan"
                          :rules="[required('peranan')]"
                          item-disabled="disable"
                          outlined
                          dense
                          item-text="peranan"
                          item-value="id"
                          v-bind:label="$t('peranan')"
                          v-on:change="tukarnegerikeadmin"
                          required
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="dialogtambahpengguna = false"
                  >
                    {{ $t("tutup") }}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="hantartambahpengguna"
                  >
                    {{ $t("hantar") }}
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogkemaskinipengguna"
            persistent
            max-width="500px"
          >
            <v-card>
              <v-form ref="formkemaskinimaklumatpengguna">
                <v-card-title class="text-h5 grey lighten-2">
                  <span class="text-h5">{{
                    $t("kemaskinimaklumatpengguna")
                  }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-text-field v-model="semakkemaskininama" v-show="false">
                      </v-text-field>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          v-model="kemaskininama"
                          :rules="[required('nama')]"
                          v-bind:label="$t('nama')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="statussemakkemaskiniemel"
                          v-show="false"
                        >
                        </v-text-field>
                        <v-text-field
                          outlined
                          dense
                          v-model="kemaskiniemel"
                          :rules="[required('emel'), rules.email]"
                          v-bind:label="$t('emel')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          :items="lookupnegeri"
                          v-model="kemaskininegeri"
                          :rules="[required('negeri')]"
                          outlined
                          dense
                          item-text="negeri"
                          item-value="id"
                          v-bind:label="$t('negeri')"
                          :disabled="disablenegeri"
                          required
                        ></v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          v-bind:label="$t('Status Enable/Disable')"
                          :rules="[required('status')]"
                          :items="['Enable','Disable']"
                          v-model="kemaskinistatus"
                          outlined
                          dense
                          item-text="Status"
                        ></v-select>
                      </v-col>
                      <!-- <v-col
                                    cols="12"
                                > -->
                      <!-- <v-select
                                :items="lookupperanan"
                                v-model="kemaskiniperanan"
                                :rules="[required('peranan')]"
                                outlined dense
                                item-text="peranan"
                                item-value="id"
                                v-bind:label="$t('peranan')"
                                required
                                ></v-select> -->
                      <!-- </v-col> -->

                      <v-col cols="4">
                        <v-checkbox
                          v-model="perananpilihan"
                          label="ADMIN"
                          value="ADMIN"
                          :disabled="disableperananadmin"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="4">
                        <v-checkbox
                          v-model="perananpilihan"
                          label="PP"
                          value="PP"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="4">
                        <v-checkbox
                          v-model="perananpilihan"
                          label="PO"
                          value="PO"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="4">
                        <v-checkbox
                          v-model="perananpilihan"
                          label="FE/DE"
                          value="FE"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="red accent-4 white--text"
                    @click="dialogkemaskinipengguna = false"
                  >
                    {{ $t("tutup") }}
                    <v-icon dark right> mdi-close-circle</v-icon>
                  </v-btn>
                  <v-btn
                    color="light-blue white--text"
                    @click="hantarkemaskinipengguna()"
                  >
                    {{ $t("simpan") }}
                    <v-icon dark right> mdi-content-save</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </template>
      </v-data-table>
    </v-card>
    </v-card>
  </div>
</template>
<script>
import i18n from "@/i18n";
import axios from "../../plugins/axios";
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();
export default {
  name: "Penggunasistem",
  setup() {},
  computed: {},
  data: () => ({
    disableperananadmin:false,
    disablenegeri: false,
    snackbar: "",
    perananpilihan: [],
    dialogtambahpengguna: false,
    dialogkemaskinipengguna: false,
    search: "",
    statussemakkemaskininama: false,
    statussemakkemaskiniemel: false,
    carinamapengguna: "",
    cariemelpengguna: "",
    cariperananpengguna: "",
    daftarnama: "",
    daftaremel: "",
    daftaperanan: "",
    daftarnegeri: "",
    idpengguna: "",
    semakkemaskininama: "",
    kemaskininama: "",
    required(text) {
      return (v) =>
        (v && v.length > 0) || `${i18n.t(text)} ${i18n.t("adalahdiperlukan")}`;
    },
    emelsudahwujud: () => true || this.msgkemaskiniemelsudahwujud,
    namamin6: () => true || this.msgnamamin6,
    rules: {
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || `${i18n.t("emeltidaklengkap")}`;
      },
    },
    msgnamamin6: "",
    msgkemaskiniemelsudahwujud: "",
    kemaskiniemel: "",
    semakkemaskiniemel: "",
    kemaskininegeri: "",
    kemaskiniperanan: "",
    kemaskinistatus:"",
    lookupnegeri: [],
    carilookupperanan: [],
    daftarlookupperanan: [],
    datapengguna: [],
    item: [
      {
        text: i18n.t("utama"),
        disabled: false,
        href: "paparanutama",
      },
      {
        text: i18n.t("penggunasistem"),
        disabled: true,
        href: "",
      },
    ],
    headers: [
      {
        text: "Bil.",
        align: "start",
        sortable: false,
        value: "no",
      },
      { text: i18n.t("nama"), value: "nama" },
      { text: i18n.t("emel"), value: "emel" },
      { text: i18n.t("negeri"), value: "negeri" },
      // { text: i18n.t("statuslogmasuk"), value: "statuslogmasuk" },
      { text: i18n.t("statusakaun"), value: "statusakaun" },
    ],
  }),
  mounted() {
    // this.semuadatapengguna()
    this.lookup();
  },
  methods: {
    async tukarnegerikeadmin(){
      if(this.daftaperanan === "ADMIN"){
         this.daftarnegeri = '20'
      }
    },
    async lookup() {
      this.userData = localStorageData.user()
      console.log(this.userData)
      console.log(this.userData.role)
      if(this.userData.role !== 'ADMIN'){
        this.daftarnegeri = this.userData.kodneg
        this.disablenegeri = true
        this.disableperananadmin = true
      }
      await axios
        .get(`${process.env.VUE_APP_API_URL}/penggunasistem/lookup`)
        .then((response) => {
          this.lookupnegeri = response.data.lookupnegeri;
          this.carilookupperanan = response.data.carilookupperanan;
          this.daftarlookupperanan = response.data.daftarlookupperanan;
        })
        .catch((error) => {
          console.log(error);
          alert(error);
        });
    },
    async caridatapengguna() {
      // this.cariemelpengguna
      // this.search
      // alert(`${this.cariemelpengguna} ${this.search}`)
      this.semuadatapengguna();
    },
    async modaltambahpengguna() {
      this.dialogtambahpengguna = true;
      // this.$refs.formtambahpengguna.resetValidation();
    },
    async hantartambahpengguna() {
      if (this.$refs.formtambahpengguna.validate()) {
        const daftarpengguna = {
          daftarnama: this.daftarnama,
          daftaremel: this.daftaremel,
          daftaperanan: this.daftaperanan,
          daftarnegeri: this.daftarnegeri,
        };
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/penggunasistem/daftarpengguna`,
            daftarpengguna
          )
          .then((response) => {
            if (response.data.status) {
              this.$refs.formtambahpengguna.reset();
              this.$refs.formtambahpengguna.resetValidation();
              this.snackbar = {
                message: i18n.t("berjaya"),
                timeout: 2000,
                color: "success",
                show: true,
              };
            }
          })
          .catch((error) => {
            console.log(error);
            alert(error);
          });

        // this.semuadatapengguna()
      }
    },
    async semuadatapengguna() {
      let tapisandatapengguna = {
        //negeri: "01",
        negeri: this.daftarnegeri,
        name: this.carinamapengguna,
        emel: this.cariemelpengguna,
        peranan: this.cariperananpengguna,
      };
      await axios
        .get(`${process.env.VUE_APP_API_URL}/penggunasistem/paparpengguna`, {
          params: tapisandatapengguna,
        })
        .then((response) => {
          this.datapengguna = response.data.data;
          // console.log(res.data.data)
          // let list=[];
          // res.data.data.map(function(pengguna) {
          //     list.push(pengguna.name);e
          // });
          // console.log(res.data.data)eee
          // this.datapengguna = res.data.data
        })
        .catch((error) => {
          console.log(error);
          alert(error);
        });
    },
    async modalkemaskinidatapengguna(row) {
      await axios
        .post(
          `${process.env.VUE_APP_API_URL}/penggunasistem/paparmaklumatpengguna`,
          { idpengguna: row.id }
        )
        .then((response) => {
          console.log(response.data.data)
          this.idpengguna = response.data.data.id;
          this.semakkemaskininama = response.data.data.name;
          this.kemaskininama = response.data.data.name;
          this.kemaskiniemel = response.data.data.email;
          this.semakkemaskiniemel = response.data.data.email;
          this.kemaskininegeri = response.data.data.state;
          this.kemaskiniperanan = response.data.data.role;
          this.perananpilihan = response.data.maklumatperanan;
          this.dialogkemaskinipengguna = true;
          this.emelsudahwujud = true;
          this.kemaskinistatus = response.data.data.accountStatus;
          this.msgkemaskiniemelsudahwujud = "";
        })
        .catch((error) => {
          console.log(error);
          alert(error);
        });
    },
    async hantarkemaskinipengguna() {
      if (this.$refs.formkemaskinimaklumatpengguna.validate()) {
        if (this.semakkemaskiniemel === this.kemaskiniemel) {
          this.statussemakkemaskiniemel = true;
        }
        const kemaskinidatapengguna = {
          emelsudahwujud: this.statussemakkemaskiniemel,
          idpengguna: this.idpengguna,
          kemaskininama: this.kemaskininama,
          kemaskiniemel: this.kemaskiniemel,
          kemaskininegeri: this.kemaskininegeri,
          kemaskiniperanan: this.perananpilihan,
          kemaskinistatus: this.kemaskinistatus
        };
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/penggunasistem/kemaskinimaklumatpengguna`,
            kemaskinidatapengguna
          )
          .then((response) => {
            console.log(response.data.status);
            this.semuadatapengguna();
            if (!response.data.status) {
              if (response.data.msg === "emel sudah wujud") {
                this.msgkemaskiniemelsudahwujud = i18n.t("emelsudahwujud");
                this.emelsudahwujud = false;
              } else {
                this.snackbar = {
                  message: i18n.t("gagal"),
                  timeout: 2000,
                  color: "red darken-4",
                  show: true,
                };
              }
              return;
            }
            this.snackbar = {
              message: i18n.t("berjaya"),
              timeout: 2000,
              color: "success",
              show: true,
            };
            this.dialogkemaskinipengguna = false;
          })
          .catch((error) => {
            console.log(error);
            alert(error);
          });
      }
    },
    warnastatuslogmasuk(status) {
      if (status === "Login") {
        return "green--text";
      } else {
        return "red--text";
      }
    },
    statusakaun(status) {
      if (status === "Enable") {
        return "green--text";
      } else {
        return "red--text";
      }
    },
  },
  watch: {
    async daftaremel(val) {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (pattern.test(val)) {
        const keputusansemakemel = await axios.post(
          `${process.env.VUE_APP_API_URL}/penggunasistem/semakemel`,
          { semakemel: val }
        );
        if (!keputusansemakemel.data.status) {
          this.msgkemaskiniemelsudahwujud = i18n.t("emelsudahwujud");
          this.emelsudahwujud = false;
        } else {
          this.msgkemaskiniemelsudahwujud = "";
          this.emelsudahwujud = true;
        }
      }
    },
    async daftarnama(val) {
      if (val.length < 4) {
        this.msgnamamin6 = `${i18n.t("minimum")} 4`;
        this.namamin6 = false;
      } else {
        this.msgnamamin6 = ``;
        this.namamin6 = true;
      }
    },
  },
};
</script>